import React from 'react'
import BlackModalBg from './BlackModalBg'
import classes from "./LoaderSpinner.module.css"

const LoaderSpinner = () => {
  return (
    <BlackModalBg>
      <div
          className={`${classes["roadmap-v2-inner-wrapper"]} ${classes["roadmap-v2-inner-wrapper-moon"]}`}
        >
          <img
            id={classes["moon"]}
            src="http://www.clker.com/cliparts/8/4/7/a/12279737022024966533rg1024_Moon_in_comic_style.svg"
            alt="moon"
          />
          <div className={classes["rocket"]}>
            <img
              src="https://maxcdn.icons8.com/Share/icon/Transport//rocket1600.png"
              alt="rocket"
              width="20%"
            />
          </div>
        </div>
    </BlackModalBg>
  )
}

export default LoaderSpinner